module.exports = __webpack_public_path__ + "PTMETTAhome-10.e775cbb1.png";